export class EstadoEntiI{
  id: String;
  nombre: String;
  descripcion: String;
}
